import React from 'react'
import Icon from '@/modern/components/Icon'
import { Favorite } from './style'

export default ({
  id,
  isHorizontal = false,
  filled = false,
  onClick = () => {},
}) => {
  const heart = {
    color: filled ? '#f3123c' : '#686976',
    icon: filled ? 'Heart_2' : 'Heart_1',
  }
  const dataTestLabel = 'card_favorite'
  const dataTestLabelId = `${dataTestLabel}_${id}`

  return (
    <Favorite
      data-qa="card_favorite"
      data-test-component={dataTestLabel}
      data-test-id={dataTestLabelId}
      wasFilled={filled}
      onClick={onClick}
    >
      <Icon
        name={heart.icon}
        fill={heart.color}
        size={isHorizontal ? '18' : '16'}
      />
    </Favorite>
  )
}
